// extracted by mini-css-extract-plugin
export var modal = "_sz-0";
export var table = "_sz-1";